import { getLinkDim } from './getLinkDim';
export function getLinkDelta(link) {
    if (link.pseudo === false) {
        return getLinkDim(link) === 1
            ? link.signal.delta
            : link.axis === 'x'
                ? link.signal.x.delta
                : link.signal.y.delta;
    }
}
//# sourceMappingURL=getLinkDelta.js.map